module.exports = __webpack_public_path__ + "img/8d.5d297306.jpg";